<template>

    <v-layout v-if="showNavigation" row>

        <v-flex md12 xs12 mt-2>

            <v-layout justify-center style="margin-bottom: 20px;">

                <v-btn
                    key="back"
                    class="ma-1 button"
                    @click="back()"
                    color="navBackButtonColor"
                    style="color: var(--v-navBackButtonTextColor-base)"
                    v-if="isNotFirst && navigation.backVisible"
                    :disabled="getRecalculationInProgress || getSendDijtajekoztatoInProgress"
                    large
                >

                    {{ navigation.backLabel }}
                    <v-icon class="ml-1" v-if="navigation.backIcon"> {{ navigation.backIcon }}</v-icon>

                </v-btn>

                <v-btn
                    key="save"
                    class="ma-1 button"
                    @click="save()"
                    color="secondaryButtonColor"
                    style="color: var(--v-secondaryButtonTextColor-base);"
                    v-if="isNotLast && navigation.saveVisible"
                    :disabled="getRecalculationInProgress || getSendDijtajekoztatoInProgress"
                    large
                >

                    {{ navigation.saveLabel }}
                    <v-icon class="ml-1" v-if="navigation.saveIcon"> {{ navigation.saveIcon }}</v-icon>

                </v-btn>

                <v-btn
                    key="next"
                    class="ma-1 button"
                    @click="next()"
                    color="navNextButtonColor"
                    style="color: var(--v-navNextButtonTextColor-base);"
                    v-if="isNotLast && navigation.nextVisible"
                    :disabled="getRecalculationInProgress || getSendDijtajekoztatoInProgress"
                    large
                >

                    {{ navigation.nextLabel }}
                    <v-icon class="ml-1" v-if="navigation.nextIcon"> {{ navigation.nextIcon }}</v-icon>

                </v-btn>

            </v-layout>

            <v-spacer></v-spacer>

        </v-flex>

    </v-layout>

</template>

<script>
import { mapGetters } from 'vuex';
import { COLOR_TYPE } from '../../modules/AppTheme';
import navigation from '../../modules/navigation';

export default {
    name: 'BnNavigationButtons',
    props: {
        color: {
            type: String,
            default: 'secondary',
        },
    },
    data() {
        return {
            navigation,
        };
    },
    methods: {
        back() {
            this.$manager.back();
        },
        save() {
            if (this.navigation.onBeforeSave) {
                this.navigation.onBeforeSave();
            } else {
                this.$manager.save();
            }
        },
        async next() {
            if (this.navigation.onBeforeNext) {
                await this.navigation.onBeforeNext();
            }
            this.$manager.next();
        },
    },
    computed: {
        ...mapGetters([
            'getRecalculationInProgress',
            'getSendDijtajekoztatoInProgress',
        ]),
        currentPage() {
            return this.$store.getters.currentPage;
        },
        isNotLast() {
            return this.$store.getters.currentPage !== this.$store.getters.getAvailablePages.length - 1;
        },
        isNotFirst() {
            return this.$store.getters.currentPage !== 0;
        },
        getStyle() {
            return `color: ${this.$theme.getColor(COLOR_TYPE.PRIMARY)};`;
        },
        showNavigation() {
            return this.navigation.backVisible || this.navigation.saveVisible || this.navigation.nextVisible;
        }
    },
};
</script>
